var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnPortAggregatingDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 14.1429C21 14.7112 20.7742 15.2562 20.3724 15.6581C19.9705 16.0599 19.4255 16.2857 18.8571 16.2857C18.2888 16.2857 17.7438 16.0599 17.3419 15.6581C16.9401 15.2562 16.7143 14.7112 16.7143 14.1429C16.7143 13.5745 16.9401 13.0295 17.3419 12.6276C17.7438 12.2258 18.2888 12 18.8571 12C19.4255 12 19.9705 12.2258 20.3724 12.6276C20.7742 13.0295 21 13.5745 21 14.1429Z",
    fill: "#373737",
    stroke: "#373737",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2861 9.14286C13.2861 9.71118 13.0604 10.2562 12.6585 10.6581C12.2566 11.0599 11.7116 11.2857 11.1433 11.2857C10.575 11.2857 10.0299 11.0599 9.62805 10.6581C9.22618 10.2562 9.00042 9.71118 9.00042 9.14286C9.00042 8.57454 9.22618 8.02949 9.62805 7.62763C10.0299 7.22576 10.575 7 11.1433 7C11.7116 7 12.2566 7.22576 12.6585 7.62763C13.0604 8.02949 13.2861 8.57454 13.2861 9.14286Z",
    stroke: "#373737",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2861 19.9998C13.2861 20.5681 13.0604 21.1132 12.6585 21.515C12.2566 21.9169 11.7116 22.1426 11.1433 22.1426C10.575 22.1426 10.0299 21.9169 9.62805 21.515C9.22618 21.1132 9.00042 20.5681 9.00042 19.9998C9.00042 19.4315 9.22618 18.8864 9.62805 18.4846C10.0299 18.0827 10.575 17.8569 11.1433 17.8569C11.7116 17.8569 12.2566 18.0827 12.6585 18.4846C13.0604 18.8864 13.2861 19.4315 13.2861 19.9998Z",
    stroke: "#373737",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8594 13.3662L13.1405 10.9199",
    stroke: "#373737",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9402 15.1016L13.0602 18.0416",
    stroke: "#373737",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnPortAggregatingDark);
export default __webpack_public_path__ + "static/media/icn_port_aggregating_Dark.87c37fbc6b3788ce4885887e1c9c68db.svg";
export { ForwardRef as ReactComponent };